import { render } from "./orphanedComp.vue?vue&type=template&id=72d805c6&scoped=true"
import script from "./orphanedComp.vue?vue&type=script&lang=js"
export * from "./orphanedComp.vue?vue&type=script&lang=js"

import "./orphanedComp.vue?vue&type=style&index=0&id=72d805c6&lang=css"
import "./orphanedComp.vue?vue&type=style&index=1&id=72d805c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d805c6"]])

export default __exports__